import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../../../../icon/src';
export const PaginationItem = (_a) => {
    var { onClick, state = 'default' } = _a, props = __rest(_a, ["onClick", "state"]);
    const getInnerElement = () => {
        switch (props.variant) {
            case 'previous':
                return _jsx(Icon, { name: 'chevronLeft', color: 'current' });
            case 'next':
                return _jsx(Icon, { name: 'chevronRight', color: 'current' });
            case 'ellipsis':
                return '…';
            case 'number':
                return props.number;
        }
    };
    return (_jsx("li", { "data-testid": 'nucleus-table--pagination-item', className: 'nucleus-group -nucleus-mr-px last-of-type:nucleus-mr-0', children: _jsx("button", { "aria-current": state === 'selected', disabled: state === 'disabled', onClick: onClick, className: `
        nucleus-relative nucleus-box-border nucleus-inline-flex nucleus-aspect-square nucleus-w-10 nucleus-cursor-pointer nucleus-select-none nucleus-items-center nucleus-justify-center nucleus-border-solid nucleus-font-sans nucleus-text-base
        nucleus-outline-none nucleus-transition-colors
        nucleus-border nucleus-border-neutral-200 focus-visible:nucleus-z-20 focus-visible:nucleus-transition-none
        focus-visible:nucleus-border-2 focus-visible:nucleus-border-primary-500 group-first-of-type:nucleus-rounded-l group-last-of-type:nucleus-rounded-r
        ${{
                default: `nucleus-bg-white nucleus-text-neutral-450
              hover:nucleus-z-10 hover:nucleus-bg-neutral-50 hover:nucleus-text-neutral-600
            active:nucleus-bg-neutral-200 active:nucleus-text-neutral-700`,
                disabled: 'nucleus-bg-neutral-200 nucleus-text-text-disabled nucleus-pointer-events-none',
                selected: 'nucleus-z-20 nucleus-bg-primary-50 nucleus-text-primary-500 nucleus-border-primary-500 nucleus-pointer-events-none',
            }[state]} ${props.variant === 'ellipsis' ? 'nucleus-pointer-events-none' : ''}
      `, children: getInnerElement() }) }));
};
//# sourceMappingURL=item.js.map